// ENUMS #############################################################
export enum EntityActionEventEnum {
	ENTITY_ACKNOWLEDGE = 'entityAcknowledge',
	ENTITY_ACTIVATE = 'entityActivate',
	ENTITY_ASSIGN = 'entityAssign',
	ENTITY_CHANGE_PASSWORD = 'entityChangePassword',
	ENTITY_CHANGE_STATUS = 'entityChangeStatus',
	ENTITY_COMPLAIN = 'entityComplain',
	ENTITY_CONFIGURE = 'entityConfigure',
	ENTITY_CONFIRM_FINAL_TSS_LOG_EXPORT = 'entityConfirmFinalTssLogExport',
	ENTITY_CREATE_SUBACCOUNT = 'entityCreateSubaccount',
	ENTITY_DECOMMISSION = 'entityDecommission',
	ENTITY_DELETE = 'entityDelete',
	ENTITY_DISABLE = 'entityDisable',
	ENTITY_DOWNLOAD = 'entityDownload',
	ENTITY_EXPORT = 'entityExport',
	ENTITY_EXPORT_ARCHIVING_TSS_LOGS = 'entityExportArchivingTssLogs',
	ENTITY_EXTEND = 'entityExtend',
	ENTITY_IMPORT = 'entityImport',
	ENTITY_INACTIVATE = 'entityInactivate',
	ENTITY_MANAGE_TENANT = 'entityManageTenant',
	ENTITY_PATCH = 'entityPatch',
	ENTITY_PRE_INITIALIZE_TSS = 'entityPreInitializeTss',
	ENTITY_REQUEST_TSS = 'entityRequestTss',
	ENTITY_RETURN = 'entityReturn',
	ENTITY_SELECT = 'entitySelect',
	ENTITY_SET_DEFAULT = 'entitySetDefault',
	ENTITY_SHOW_CODE = 'entityShowCode',
	ENTITY_SHOW_STRUCTURE_EXPORT = 'entityShowStructureExport',
	ENTITY_SHOW_STRUCTURE_IMPORT = 'entityShowStructureImport',
	ENTITY_SUBMIT = 'entitySubmit',
	ENTITY_SUSPEND = 'entitySuspend',
	ENTITY_TAXATION_REPORTING_CREATE = 'entityTaxationReportingCreate',
	ENTITY_TRIGGER_ERS_SYNC = 'entityTriggerErsSync',
	ENTITY_TRIGGER_FCC_DATACENTER_INSTALLATION = 'entityTriggerFccDatacenterInstallation',
	ENTITY_TSS_UPLOAD = 'entityTriggerTssUpload',
	LIST_BULK_ACKNOWLEDGE = 'listBulkAcknowledge',
	LIST_BULK_DOWNLOAD = 'listBulkDownload',
	LIST_BULK_TAXATION_REPORTING_CREATE = 'listBulkTaxationReportingCreate',
	LIST_BULK_TAXATION_REPORTING_SUBMIT = 'listBulkTaxationReportingSubmit',
	NAVIGATE_TO_CHANGE_PASSWORD_PAGE = 'navigateToChangePasswordPage',
	NAVIGATE_TO_DETAIL_PAGE = 'navigateToDetailPage',
	NAVIGATE_TO_FORM_CREATE = 'navigateToFormCreate',
	NAVIGATE_TO_FORM_UPDATE = 'navigateToFormUpdate',
	NAVIGATE_TO_USAGE = 'navigateToUsage',
	REFRESH_ENTITY = 'refreshEntity', // TODO rename to ENTITY_REFRESH, for consistency
	REFRESH_LIST = 'refreshList',	// TODO rename to LIST_REFRESH, for consistency
}

export enum EntityActionTypeEnum {
	ENTITY = 'entity',
	NAVIGATE = 'navigate',
	REFRESH = 'refresh',
}

export enum EntitySelectItemStateActionEnum {
	CLEAR = 'clear',
	RESET_TO_DEFAULT = 'resetToDefault',
	SET = 'set'
}

export enum EntityVariantEnum {
	EXTERNAL = 'external',
	INTERNAL = 'internal'
}

export enum InvalidEntityEnum {
	BUSINESS_PREMISES = 'businessPremises',
	ERS = 'ers',
	ORGANIZATION = 'organization'
}


// INTERFACES ########################################################
export interface IEntityValidationResults {
	[ key: string ]: string;
}


// CLASS #############################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class EntityErrorsTMO {
	public invalidEntities?: InvalidEntityEnum[] = undefined;
	public validationResults?: IEntityValidationResults = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class EntityErrors extends EntityErrorsTMO {}
